import { useEffect } from 'react';
import { useGetSalesmanImportInfoQuery } from '@api/import/api';
import { hasOwnPropertyTS } from '@utils/typescriptGuards';
import LoadingApp from 'components/base-elements/loading/LoadingApp';
import UploadError from '@pages/upload-pages/shared-components/UploadError';
import UploadRunning from '@pages/upload-pages/shared-components/UploadRunning';



interface CheckImportProps {
	allowUpload: () => void,
}


export const CheckImport = (props: CheckImportProps) => {
	const { allowUpload } = props;

	const { data, isSuccess, isError, error, refetch } = useGetSalesmanImportInfoQuery();

	
	useEffect(() => {
		if (isSuccess && data && data.isRunning === false) {
			allowUpload();
		}
	}, [ isSuccess, data ]);

	
	if (isError) return (
		<UploadError
			errorMessage={error && hasOwnPropertyTS(error, 'message') && typeof error.message === 'string'
				? error.message
				: error && hasOwnPropertyTS(error, 'error') && typeof error.error === 'string'
				? error.error
				: null}
			uploadReset={refetch} />
	)

	
	if (isSuccess && data && data.isRunning === true) return (
		<UploadRunning processInfo={data} reset={refetch} />
	)
	
	
	return (
		<LoadingApp />
	)
}

export default CheckImport;